import React from 'react';
import AuthService from './authService';

class ApolloIgnoredClientService extends React.Component{

    static GetApolloIgnoredClientList()
    {
        return AuthService.getInstance()
            .CallBackendFunction( "/api/ApolloIgnoredClient/GetApolloIgnoredClient" );
    }
    

    static AddNewApolloIgnoredClient(data)
    {
        data.clientId=parseInt(data.clientId)
        return AuthService.getInstance()
             .CallBackendFunctionPost( "/api/ApolloIgnoredClient/AddNewApolloIgnoredClient",JSON.stringify(data) );
    }
    
}

export default ApolloIgnoredClientService;